// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .group-header.is-sticky {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1000;
  padding: 16px 32px;
  margin: 0 -32px;
}
.presize-root .group-header.is-sticky .distribution-column {
  max-height: 79px;
  overflow: hidden;
}
.presize-root .group-header .group-title {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 8px;
  margin-left: 24px;
}
.presize-root .group-header .rds-link {
  font-size: inherit;
  display: inline-block;
  margin-bottom: 6px;
  padding-bottom: 0;
  cursor: pointer;
}
.presize-root [data-retail-portal-app] .group-header.is-sticky {
  top: 56px;
}
.presize-root .fallback-popover {
  width: 255px;
}
.presize-root .fallback-popover .ant-popover-title {
  font-weight: bold;
}
.presize-root .group-selector {
  position: absolute;
}
/*# sourceMappingURL=GroupHeader.css.map */`, "",{"version":3,"sources":["webpack://./GroupHeader.less","webpack://./src/components/SizingGroup/GroupHeader/GroupHeader.less"],"names":[],"mappings":"AAEE;EACE,gBAAA;EACA,MAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;ACDJ;ADLE;EAQI,gBAAA;EACA,gBAAA;ACAN;ADXA;EAgBI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;ACFJ;ADjBA;EAuBI,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;ACHJ;ADxBA;EAiCE,SAAA;ACNF;AD3BA;EAqCE,YAAA;ACPF;AD9BA;EAuCI,iBAAA;ACNJ;ADjCA;EA4CE,kBAAA;ACRF;AACA,0CAA0C","sourcesContent":[".presize-root { \n .group-header {\n  &.is-sticky {\n    position: sticky;\n    top: 0;\n    background: #fff;\n    z-index: 1000;\n    padding: 16px 32px;\n    margin: 0 -32px;\n    .distribution-column {\n      max-height: 79px;\n      overflow: hidden;\n    }\n  }\n\n  .group-title {\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 8px;\n    margin-left: 24px;\n  }\n\n  .rds-link {\n    font-size: inherit;\n    display: inline-block;\n    margin-bottom: 6px;\n    padding-bottom: 0;\n    cursor: pointer;\n  }\n}\n\n\n[data-retail-portal-app] .group-header.is-sticky {\n  top: 56px; // rc header height + border\n}\n\n.fallback-popover {\n  width: 255px;\n  .ant-popover-title {\n    font-weight: bold;\n  }\n}\n\n.group-selector {\n  position: absolute;\n}\n \n}",".presize-root .group-header.is-sticky {\n  position: sticky;\n  top: 0;\n  background: #fff;\n  z-index: 1000;\n  padding: 16px 32px;\n  margin: 0 -32px;\n}\n.presize-root .group-header.is-sticky .distribution-column {\n  max-height: 79px;\n  overflow: hidden;\n}\n.presize-root .group-header .group-title {\n  font-size: 16px;\n  line-height: 24px;\n  margin-bottom: 8px;\n  margin-left: 24px;\n}\n.presize-root .group-header .rds-link {\n  font-size: inherit;\n  display: inline-block;\n  margin-bottom: 6px;\n  padding-bottom: 0;\n  cursor: pointer;\n}\n.presize-root [data-retail-portal-app] .group-header.is-sticky {\n  top: 56px;\n}\n.presize-root .fallback-popover {\n  width: 255px;\n}\n.presize-root .fallback-popover .ant-popover-title {\n  font-weight: bold;\n}\n.presize-root .group-selector {\n  position: absolute;\n}\n/*# sourceMappingURL=GroupHeader.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
